import { render, staticRenderFns } from "./hocAnimatedOverlay.vue?vue&type=template&id=3028dce8&"
import script from "./hocAnimatedOverlay.vue?vue&type=script&lang=js&"
export * from "./hocAnimatedOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports